<template>
    <div class="l3-cont">
        <img src="@/assets/temimg4/pie-bg.png" class="bg1" alt="">
        <img src="@/assets/temimg4/pie-bg.png" class="bg2" alt="">
        <div v-for="(item, i) in 2">
            <div :class="`val-text${item}`">{{ defaultdata[i].value2 }}</div>
            <div :class="`name-text${item}`">{{ defaultdata[i].value1 }}</div>
        </div>
        <div class="l3-item" ref="cir1">
        </div>
        <div class="l3-item" ref="cir2">
        </div>
    </div>
</template>

<script>
import * as methods from "./method.js";
export default {
    name: "template.scope128",
    props: {
        vdata: {
            type: [Array, String],
            default: () => [],
        },
        jsondata: {
            type: [Array, String],
            default: () => [],
        },
        scopedata: {
            type: Object,
            default: () => { },
        },
    },
    data() {
        return {
            timer: null,
            defaultdata: [
                { value1: '数据一', value2: '12', value3: '23' },
                { value1: '数据二', value2: '22', value3: '66' },
            ],
            valueMap: [
                { name: '名称', key: 'value1' },
                { name: '数值', key: 'value2' },
                { name: '占比', key: 'value3' },
            ],
            exceldata: [],
            apiconfig: {},
            isApi: false,
            scope: {},
        }
    },
    watch: {
        vdata(n) {
            if (n && n.length) {
                let vdatalist = n.filter(item => {
                    let vlist = Object.keys(item)
                    let isdata = false
                    vlist.forEach(del => {
                        if (item[del] == undefined) {
                            item[del] = ''
                        } else if (del && item[del]) {
                            isdata = true
                        }
                    })
                    if (vlist.length && isdata) return item
                })
                this.defaultdata = vdatalist.slice(0, 2)
            }
        },
        jsondata(n) {
            this.exceldata = n;
        },
        defaultdata(n) {
            this.drawChart1()
            this.drawChart2()
        },
    },
    methods: {
        ...methods,
        drawChart1() {
            var echarts = require('echarts');
            let dom = this.$refs.cir1
            var myChart = echarts.init(dom);
            let vdata = this.defaultdata[0]
            var option = {
                angleAxis: {
                    max: vdata.value3, // 满分
                    clockwise: true, // 逆时针
                    // 隐藏刻度线
                    axisLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        show: false
                    },
                    splitLine: {
                        show: false
                    }
                },
                radiusAxis: {
                    type: 'category',
                    // 隐藏刻度线
                    axisLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        show: false
                    },
                    splitLine: {
                        show: false
                    }
                },
                polar: {
                    center: ['53%', '50%'],
                    radius: '88%' //图形大小
                },
                series: [{
                    type: 'bar',

                    data: [{
                        name: '',
                        value: vdata.value2,
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [{
                                    offset: 0,
                                    color: '#aaf14f'
                                }, {
                                    offset: 1,
                                    color: '#0acfa1'
                                }])
                            }
                        },
                    }],
                    coordinateSystem: 'polar',
                    roundCap: true,
                    barWidth: 8,
                    barGap: '-100%', // 两环重叠
                    z: 2,
                }, { // 灰色环
                    type: 'bar',
                    data: [{
                        value: vdata.value3,
                        itemStyle: {
                            color: '#424559',
                            shadowColor: 'rgba(0, 0, 0, 0.2)',
                            shadowBlur: 5,
                            shadowOffsetY: 2
                        }
                    }],
                    coordinateSystem: 'polar',
                    roundCap: true,
                    barWidth: 8,
                    barGap: '-100%', // 两环重叠
                    z: 1
                }]
            };
            option && myChart.setOption(option);
            setInterval(function () {
                myChart.clear();
                option && myChart.setOption(option);

            }, 5000)
        },
        drawChart2() {
            var echarts = require('echarts');
            let dom = this.$refs.cir2
            var myChart = echarts.init(dom);
            let vdata = this.defaultdata[0]
            var option = {
                angleAxis: {
                    max: vdata.value3, // 满分
                    clockwise: true, // 逆时针
                    // 隐藏刻度线
                    axisLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        show: false
                    },
                    splitLine: {
                        show: false
                    }
                },
                radiusAxis: {
                    type: 'category',
                    // 隐藏刻度线
                    axisLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        show: false
                    },
                    splitLine: {
                        show: false
                    }
                },
                polar: {
                    center: ['47%', '50%'],
                    radius: '88%' //图形大小
                },
                series: [{
                    type: 'bar',

                    data: [{
                        name: '',
                        value: vdata.value2,
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                    offset: 0,
                                    color: '#3987fe'
                                }, {
                                    offset: 0.5,
                                    color: '#3987fe'
                                }, {
                                    offset: 1,
                                    color: '#5ce0fe'
                                }])
                            }
                        },
                    }],
                    coordinateSystem: 'polar',
                    roundCap: true,
                    barWidth: 8,
                    barGap: '-100%', // 两环重叠
                    z: 2,
                }, { // 灰色环
                    type: 'bar',
                    data: [{
                        value: vdata.value3,
                        itemStyle: {
                            color: '#424559',
                            shadowColor: 'rgba(0, 0, 0, 0.2)',
                            shadowBlur: 5,
                            shadowOffsetY: 2
                        }
                    }],
                    coordinateSystem: 'polar',
                    roundCap: true,
                    barWidth: 8,
                    barGap: '-100%', // 两环重叠
                    z: 1
                }]
            };
            option && myChart.setOption(option);
            setInterval(function () {
                myChart.clear();
                option && myChart.setOption(option);

            }, 5000)
        }
    },
    mounted() {
        if (this.vdata && this.vdata.length) {
            this.defaultdata = this.vdata;
        }
        if (this.jsondata && this.jsondata.length) {
            this.exceldata = this.jsondata;
        }
        this.setData()
        this.drawChart1()
        this.drawChart2()
    }
}
</script>

<style lang="scss" scoped>
.l3-cont {
    width: 435px;
    height: 240px;
    padding: 10px 0;
    display: flex;
    align-items: center;
    position: relative;

    img {
        width: 201.5px;
        height: 201.5px;
        position: absolute;
        z-index: 1;
        pointer-events: none;
    }

    .bg1 {
        left: 15px;
        top: 30px;
    }

    .bg2 {
        right: 15px;
        top: 30px;
    }

    .l3-item {
        width: 50%;
        height: 100%;
        position: relative;
    }
    .val-text1,
    .val-text2 {
        font-family: Benmo Ziyu;
        font-weight: 400;
        font-size: 24px;
        color: #FFFFFF;
        line-height: 24px;
        position: absolute;
        top: 120px;
        max-width: 100px;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .val-text1 {
        left: 27%;
        transform: translateX(-50%);
    }
    .val-text2 {
        right: 27%;
        transform: translateX(50%);
    }
    .name-text1,
    .name-text2 {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 16px;
        color: #FFFFFF;
        line-height: 16px;
        position: absolute;
        bottom: 20px;
        max-width: 140px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
    .name-text1 {
        left: 27%;
        transform: translateX(-50%);
    }
    .name-text2 {
        right: 27%;
        transform: translateX(50%);
    }
}
</style>